#import "../../../../../core-entity/widgets/email-sequences-widget/graphql/fragments/email-automation-statuses-fragment.graphql"

fragment LeadPersonalEmailSequencesFragment on Lead {
    id
    stages {
        edges {
            node {
                id
                name
            }
            isActive
            emailAutomationStatuses {
                ...EmailAutomationStatusesFragment
            }
        }
    }
}
